export default {
  text: 'Ai câștigat {{points}} puncte ({{amount}}) la această comandă',
  button: 'Autentifică-te și revendică punctele',
};
